<template>
	<div class="selection-box pr overflow-hidden">
		<div class="box-head flex justify-between">
			<strong class="title fw5 f5">Sources</strong>

			<span :class="[`link pointer`, {'disabled': !allSourcesActive}]" @click="onSelectAll">select all
				<span class="circle">
					<img src="../../../assets/images/check.svg" alt="check">
				</span>
			</span>
		</div>

		<ul class="sources-list flex flex-wrap">
			<li v-for="(src) in sources" :class="$css(styles.sourceLi)" :key="src">
				<div :class="[`source-button flex flex-column flex-wrap justify-center items-center pointer`, {active : ~activeSources.indexOf(src) }]"
				:data-source="src" @click="(e)=> onSourceChange(e, src)" @contextmenu="(e)=> onSourceChange(e, src, true)">

					<svg viewBox="0 0 24 24">
						<path :d="sourceIcons[src.toUpperCase()]"></path>
					</svg>
					<span :class="[`label items-center justify-center flex-wrap db fw6`, $css(styles.label)]">
						{{capitalize((sourcesNames[src] ? sourcesNames[src] : src).replace("_", " "))}}
					</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import capitalize from "lodash/capitalize";
	import { mapState, mapActions } from "vuex";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import {types, sourcesNames} from "@/store/modules/widget";
	import {SOURCES} from "../../assets/icons";

	function styles() {
		return this.$style({
			sourceLi: gimq(MQ_SIZES.S, {width: "33.333%"}),
			label: gimq(MQ_SIZES.M, {fontSize: "10px"})
		});
	}

	export default {
		name: "SourcesWidget",
		data(){
			return {
				sourceIcons: SOURCES,
				sourcesNames: sourcesNames
			};
		},
		computed: {
			...mapState({
				sources: (state) => state.widget.sources,
				activeSources: (state) => state.widget.activeSources,
				allSourcesActive: (state) =>
					state.widget.activeSources.length < state.widget.sources.length,
			}),
			styles
		},
		methods: {
			...mapActions("widget",[
				types.TOGGLE_SOURCE,
				types.SET_ALL_SOURCES_ON,
			]),
			capitalize,
			onSourceChange(e, src, rightClick = false) {

				if (rightClick){
					e.preventDefault();
					e.stopPropagation();
				}

				this[types.TOGGLE_SOURCE]({src: src, only: rightClick});
			},
			onSelectAll(){
				this[types.SET_ALL_SOURCES_ON]();
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../assets/scss/_variables";

	.selection-box {
		border-bottom: 1px solid $heather;
		padding: 0 0 5px;
	}

	.box-head {
		margin: 0 0 10px;
		padding: 0 11px 0 0;

		.title {
			/*text-transform: uppercase;*/
		}

		.link {
			position: relative;
			display: flex;
			flex-direction: row;
			align-items: center;
			letter-spacing: 0.06px;
			color: $blue1;

			.circle {
				width: 15px;
				height: 15px;

				background: $blue1;
				border-radius: 100%;
				padding: 3px 3px 0 3px;
				margin: 0 0 0 5px;

				img {
					margin-bottom: 1px;
				}
			}

			&.disabled {
				color: $gray;
				cursor: default;

				.circle {
					background: $gray;
				}
			}
		}
	}

	.sources-list {

		margin: 0 -4px;

		li {
			padding: 0 4px;
			width: 25%;
			margin: 0 0 8px;

			.source-button {
				height: 64px;
				border: 2px solid transparent;
				border-radius: 4px;

				svg {
					display: block;
					margin: 4px auto 6px;
					width: 24px;

					path {
						fill: $downriver
					}
				}

				&:hover {
					border-color: $catskill;
				}

				&.active {
					border-color: $dodger;

					svg path {
						fill: $azure;
					}

					background: $catskill;

					.label {
						color: $dodger;
					}
				}

				.label {
					border: 2px solid transparent;
					border-radius: 4px;
					display: block;
				}
			}
		}
	}

</style>
